import { render, staticRenderFns } from "./exchange-confirm.vue?vue&type=template&id=2839fdd2&scoped=true&"
import script from "./exchange-confirm.vue?vue&type=script&lang=ts&"
export * from "./exchange-confirm.vue?vue&type=script&lang=ts&"
import style0 from "./exchange-confirm.vue?vue&type=style&index=0&id=2839fdd2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2839fdd2",
  null
  
)

export default component.exports